export default __webpack_public_path__ + "static/park-pedregal-amenidades-06-alberca-panoramica-90f096b020f91acfbb3ee638756a4933.jpg";